import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from './user/user.service';

@Injectable({
  providedIn: 'root'
})
export class NotFoundGuard {

  public constructor(
    private userService: UserService,
    private router: Router,
  ) { }

  public canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (!this.userService.loggedConsult) {
      this.router.navigate(['/login']);
      return false;
    }

    return true;
  }
}